import { isNotDefined } from '@sgme/fp';
import classNames from 'classnames';
import { useFocusRef } from 'hooks/useFocusRef';
import { FC, KeyboardEvent, MouseEvent, useMemo } from 'react';

type ReadOnlyLabelProps = {
  id: string;
  e2e: string;
  className?: string;
  value: unknown;
  isSelected: boolean | undefined;
  isReadOnly: boolean | undefined;
  isCustomized: boolean | undefined;

  formatValue?: (value: string) => string;

  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  onDoubleClick: (e: MouseEvent<HTMLElement>) => void;
  onClick: (e: MouseEvent<HTMLElement>) => void;
};

export const ReadOnlyLabel: FC<ReadOnlyLabelProps> = ({
  id,
  className,
  e2e,
  onKeyDown,
  onDoubleClick,
  onClick,
  value,
  isSelected,
  isReadOnly,
  isCustomized,
  formatValue,
}) => {
  const inputRef = useFocusRef(isSelected ?? false);

  const textValue = useMemo(() => {
    if (isNotDefined(value)) {
      return '';
    }
    const textValue = (value as any).toString();
    if (formatValue !== undefined) {
      return formatValue(textValue);
    }
    return textValue;
  }, [value, formatValue]);

  return (
    <input
      type="text"
      readOnly
      id={id}
      data-e2e={e2e}
      className={classNames('form-control clickable', className, {
        'bg-info bg-opacity-20': isSelected && !isReadOnly,
        'bg-secondary bg-opacity-40': isSelected && isReadOnly,
        'text-info': isCustomized,
      })}
      onDoubleClick={onDoubleClick}
      onClick={onClick}
      onKeyDown={onKeyDown}
      value={textValue}
      ref={inputRef}
    />
  );
};
